import React from 'react';
import { Box, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { makeStyles } from 'tss-react/mui';

import { SiteRouterLink } from '../../../../components/RouterLink';
import { useI18n } from '../locales';
import { useUrlWithNext } from '../../../utils';

const useStyles = makeStyles()({
	root: {
		position: 'absolute',
		background: 
		'white',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: 2
	}
})

interface Props {
	email: string
}

export function AuthRegisterFormSuccess(props: Props) {
	const { classes } = useStyles();
	const { t, Trans } = useI18n();
	const loginURL = useUrlWithNext("/auth/login/");
	return (
		<Box sx={{
			position: 'absolute',
			background: 'white',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			zIndex: 2,
			textAlign: 'center',
			boxSizing: 'border-box',
			py: 3
		}}>
			<Typography
				display='block'
				fontSize={14}
				mb={2}
				textAlign='center'
			>
				{t('Account successfully created')}.{' '}
				<Trans
					i18nKey='We have sent an email with further instructions on how to activate your account to <0>{{email}}</0>'
					components={[
						<Typography
							color="primary"
							fontSize='inherit'
						/>
					]}
					values={{email: props.email}}
				/>.
			</Typography>
			<SiteRouterLink
				to={loginURL}
				display='inline-flex'
				alignItems='center'
				underline='none'
			>
				<>
					<Box mr={0.5}>
						{t('actions.Sign in')}
					</Box>
					<LoginIcon fontSize='small' />
				</>
			</SiteRouterLink>
		</Box>
	);
}
